import { ColDef } from "@ag-grid-community/core";

import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import FieldType from "@mapmycustomers/shared/enum/fieldModel/FieldType";

export const defaultFilterParams: { [key: string]: any } = {
  buttons: ["reset", "apply"],
  closeOnApply: false,
} as const;

const baseColumnTypes: Record<FieldFeature | FieldType, ColDef> = {
  [FieldFeature.ACTIVITY_TYPE_FIELD]: {},
  [FieldFeature.ADDRESS]: {},
  [FieldFeature.ALWAYS_VISIBLE]: {
    lockVisible: true,
  },
  [FieldFeature.ASSOCIATED_ENTITY]: {},
  [FieldFeature.BULK_ADDRESS]: {},
  [FieldFeature.BULK_EDIT]: {},
  [FieldFeature.CALCULATED_FIELD]: {},
  [FieldFeature.CHECK_IN]: {},
  [FieldFeature.CLASSIFICATION_FIELD]: {},
  [FieldFeature.COLOR_FIELD]: {},
  [FieldFeature.COMPANY_ADDRESS_FIELD]: {},
  [FieldFeature.COUNTRY_FIELD]: {},
  [FieldFeature.CUSTOM_FIELD]: {},
  [FieldFeature.DATA_VIEW]: {},
  [FieldFeature.DEAL_ADDRESS_FIELD]: {},
  [FieldFeature.DETAILS]: {},
  [FieldFeature.EMAIL_DYNAMIC_VAR]: {},
  [FieldFeature.ENGAGEMENT]: {},
  [FieldFeature.EXTERNAL_URL_FIELD]: {},
  [FieldFeature.FILE_FIELD]: {},
  [FieldFeature.FILTERABLE]: {},
  [FieldFeature.FILTERABLE_ON_MAP]: {},
  [FieldFeature.FORM_RENDERED_WITH_OTHER_FIELD]: {},
  [FieldFeature.FREQUENCY_INTERVAL]: {},
  [FieldFeature.FREQUENCY_STATUS_FIELD]: {},
  [FieldFeature.FUNNEL_FIELD]: {},
  [FieldFeature.GEO_POINT_FIELD]: {},
  [FieldFeature.GROUP_FIELD]: {},
  [FieldFeature.HISTORY_FIELD]: {},
  [FieldFeature.INCOMING]: {},
  [FieldFeature.MAP_PINNED_FIELD]: {},
  [FieldFeature.METRIC]: {},
  [FieldFeature.MONETARY_VALUE]: {},
  [FieldFeature.NO_CHECK_IN_FIELD]: {},
  [FieldFeature.NO_CONTACT_FIELD]: {},
  [FieldFeature.NON_ADDABLE_FORM_FIELD]: {},
  [FieldFeature.NON_EXPORT_VIEW]: {},
  [FieldFeature.NON_IMPORT]: {},
  [FieldFeature.NON_INTEGRATION]: {},
  [FieldFeature.NON_LIST_VIEW]: {},
  [FieldFeature.NON_MAP_VIEW]: {},
  [FieldFeature.NUMERIC]: {},
  [FieldFeature.OUTGOING]: {},
  [FieldFeature.OWNER_FIELD]: {},
  [FieldFeature.PARENT_COMPANY_ADDRESS_FIELD]: {},
  [FieldFeature.PEOPLE_ADDRESS_FIELD]: {},
  [FieldFeature.RECORD_PREVIEW_VISIBLE_BY_DEFAULT]: {},
  [FieldFeature.REGION_FIELD]: {},
  [FieldFeature.RELATIONSHIPS_CATEGORY]: {},
  [FieldFeature.REQUIRED]: {},
  [FieldFeature.ROTTING_DAYS_OUT_FIELD]: {},
  [FieldFeature.ROUTE_FIELD]: {},
  [FieldFeature.SORTABLE]: {
    sortable: true,
  },
  [FieldFeature.SOURCE_FIELD]: {},
  [FieldFeature.STAGE_FIELD]: {},
  [FieldFeature.STANDARD]: {},
  [FieldFeature.SUPPORTS_SET_FILTER]: {},
  [FieldFeature.TEAM_FIELD]: {},
  [FieldFeature.TERRITORY_FIELD]: {},
  [FieldFeature.USES_COLORS]: {},
  [FieldFeature.VIEW_AS_FIELD]: {},
  [FieldFeature.VISIBLE_BY_DEFAULT]: {},
  [FieldFeature.WITH_CHECKBOX_SELECTION]: {
    checkboxSelection: true,
  },
  [FieldType.BOOLEAN]: {},
  [FieldType.DATE]: {},
  [FieldType.DATE_TIME]: {},
  [FieldType.ID]: {},
  [FieldType.LIST]: {
    autoHeight: true,
  },
  [FieldType.NUMBER]: {},
  [FieldType.OBJECT]: {},
  [FieldType.STRING]: {},
} as const;

export default baseColumnTypes;
